import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { FormControl, Select, MenuItem } from "@material-ui/core";
import { actions } from "../../../reducers/reports/clientHistory/actions";

const NoRequirePesel = ({ userId, noRequirePesel }) => {
  const dispatch = useDispatch();

  return (
    <FormControl>
      <Select
        value={noRequirePesel}
        onChange={(event) =>
          dispatch(
            actions.changeNoRequirePeselStatus(userId, !event.target.value),
          )
        }
        inputProps={{
          name: "noRequirePesel",
          id: "noRequirePesel-picker",
        }}
      >
        <MenuItem value={true}>TAK</MenuItem>
        <MenuItem value={false}>NIE</MenuItem>
      </Select>
    </FormControl>
  );
};

NoRequirePesel.propTypes = {
  userId: PropTypes.string.isRequired,
  noRequirePesel: PropTypes.bool,
};

export default NoRequirePesel;
